import { ReloaderRecipeFormValues } from '../../app/models/reloaderRecipe'

export const RECIPE_SUBMIT_FORM_STORAGE_KEY = 'gunslop_recipe_submit_form_state'

export type RecipeSubmitPersistedState = {
  v: 1
  form: ReloaderRecipeFormValues
}

export const RECIPE_SUBMIT_RETURN_PATH = '/ammo/reloading/new'
export const RECIPE_SUBMIT_RETURN_TITLE = 'Recipe Submit'

export function normalizeRecipePersistedState (raw: Record<string, unknown>): RecipeSubmitPersistedState | null {
  if (raw?.v !== 1 || !raw.form) return null
  return { v: 1, form: raw.form as ReloaderRecipeFormValues }
}

export function saveRecipeSubmitFormState (state: Omit<RecipeSubmitPersistedState, 'v'>): void {
  const payload: RecipeSubmitPersistedState = { v: 1, form: state.form }
  sessionStorage.setItem(RECIPE_SUBMIT_FORM_STORAGE_KEY, JSON.stringify(payload))
}

export function peekRecipeSubmitFormState (): RecipeSubmitPersistedState | null {
  try {
    const raw = sessionStorage.getItem(RECIPE_SUBMIT_FORM_STORAGE_KEY)
    if (!raw) return null
    const parsed = JSON.parse(raw) as Record<string, unknown>
    return normalizeRecipePersistedState(parsed)
  } catch {
    return null
  }
}

export function consumeRecipeSubmitFormState (): RecipeSubmitPersistedState | null {
  const state = peekRecipeSubmitFormState()
  if (state) {
    sessionStorage.removeItem(RECIPE_SUBMIT_FORM_STORAGE_KEY)
  }
  return state
}

export function clearRecipeSubmitFormState (): void {
  sessionStorage.removeItem(RECIPE_SUBMIT_FORM_STORAGE_KEY)
}

export function encodeRecipeSubmitStateParam (state: Omit<RecipeSubmitPersistedState, 'v'>): string {
  return encodeURIComponent(JSON.stringify({ v: 1, ...state }))
}

export function decodeRecipeSubmitStateParam (encoded: string | null | undefined): RecipeSubmitPersistedState | null {
  if (!encoded) return null
  try {
    const parsed = JSON.parse(decodeURIComponent(encoded)) as Record<string, unknown>
    return normalizeRecipePersistedState(parsed)
  } catch {
    return null
  }
}

export function buildRecipeHelpUrl (
  field: string,
  returnTo: string,
  state?: Omit<RecipeSubmitPersistedState, 'v'>
): string {
  const params = new URLSearchParams({ returnTo })
  if (state) {
    params.set('state', encodeRecipeSubmitStateParam(state))
  }
  return `/help/ammo/${encodeURIComponent(field)}?${params.toString()}`
}

export function isRecipeSubmitReturnPath (returnTo: string): boolean {
  return returnTo.startsWith('/ammo/reloading')
}
